import { Box, styled } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";
import { PiAirplaneBold } from "react-icons/pi";
import { RiShipLine } from "react-icons/ri";

export const Subtitle = styled("div")(() => ({
  fontFamily: "Manrope",
  fontSize: "12px",
  fontWeight: 700,
  lineHeight: "16px",
  letterSpacing: "0.4px",
  textAlign: "left",
  wordBreak: "break-word",
}));

export const ShipIcon = styled(RiShipLine)(() => ({
  marginRight: "8px",
  color: "#475467",
}));

export const PlaneIcon = styled(PiAirplaneBold)(() => ({
  marginRight: "8px",
  color: colors.gray600,
}));

export const Text = styled("div")(() => ({
  fontFamily: "Manrope",
  fontSize: "12px",
  fontWeight: 400,
  lineHeight: "16px",
  letterSpacing: "0.4px",
  textAlign: "left",
}));

export const Divider = styled("div")(() => ({
  border: "0.5px solid #E4E7EC",
  width: "100%",
}));

export const Wrapper = styled("div")(() => ({
  display: "flex",
  padding: "1rem 1rem 0px 1rem",
  width: "100%",
}));

export const LocationWrapper = styled(Box)(() => ({
  display: "flex",
  gap: "8px",
}));

export const useStyles = makeStyles(() => ({
  eventItemFlex: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
}));
